// @file Network requests related to link safety from surface
/* eslint-disable no-return-await, no-template-curly-in-string */
import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { LinkSafetyCheckApiResponse } from '@@/types'
import type { JsonAPIResource, JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

class LinkSafetyCheck extends FetchableObject {
  public static readonly checkLinkSafetyUrl = `/api/\${ apiVersion }/links/check-safety`

  public static async checkLinkSafety(
    params: { url: string },
    fetchOptions: VersionedFetchOptions = { apiVersion: 1 },
  ): Promise<LinkSafetyCheckApiResponse> {
    const response: JsonAPIResponse<LinkSafetyCheckApiResponse> = await fetchJson(
      this.buildUrl(this.checkLinkSafetyUrl, fetchOptions),
      {
        method: HTTPMethod.get,
        query: params,
      },
    )
    return (response.data as JsonAPIResource<LinkSafetyCheckApiResponse>).attributes
  }
}

export default LinkSafetyCheck
